export default __webpack_public_path__ + "static/media/icon_red_hospitalaria_on.5e8acada.svg";